'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/is-pure.js
// module id = 514
// module chunks = 0